import { validateConditions } from './/validationHelpers/conditionalValidators';
import { Rules } from './validationHelpers/conditionEnums';
import { getStoreItem } from './validationHelpers/storeHandler';

export const evaluateNextUrl = (
	conditionalField: {
		andConditions?: string[];
		fieldId: string;
		fieldValue: string;
		id: string;
		url: string;
	},
	nextUrls: Navigation['nextUrls']
) => {
	// Get main data from the conditionalField
	const { fieldId, andConditions } = conditionalField ?? {};
	let { fieldValue } = conditionalField ?? {};

	// Check for wildcard condition (*)
	if (fieldValue == Rules.Any) return true;

	// Check if it's a positive or negative condition
	const isPositiveCondition = !fieldValue?.startsWith('!');
	if (!isPositiveCondition) fieldValue = fieldValue.substring(1); // Remove '!' for negative conditions

	// Get the store item for the primary field
	const storeItem = getStoreItem(fieldId, fieldValue);

	// Validate the primary condition
	const isConditionValid = validateConditions(storeItem, fieldValue, isPositiveCondition);

	// Return early if the primary condition fails
	if (!isConditionValid) return false;

	// Process all `andConditions` if present
	if (andConditions?.length) {
		for (const conditionId of andConditions) {
			// Find the dependent condition by its `id` from `nextUrls`
			const dependentCondition = nextUrls.find((urlCondition) => urlCondition.id === conditionId);

			// Skip if no dependent condition is found
			if (!dependentCondition) continue;

			// Get and validate the dependent condition
			const dependentStoreItem = getStoreItem(dependentCondition.fieldId);
			let dependentFieldValue = dependentCondition.fieldValue ?? '';
			const isDependentPositive = !dependentFieldValue.startsWith('!');

			if (!isDependentPositive) dependentFieldValue = dependentFieldValue.substring(1); // Remove '!' if negative

			const isDependentConditionValid = validateConditions(
				dependentStoreItem,
				dependentFieldValue,
				isDependentPositive
			);

			// Return false if any dependent condition is invalid
			if (!isDependentConditionValid) return false;
		}
	}

	// All conditions passed, return true
	return isConditionValid;
};
